import { render, staticRenderFns } from "./recommender.vue?vue&type=template&id=320528cb&scoped=true&"
import script from "./recommender.vue?vue&type=script&lang=js&"
export * from "./recommender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320528cb",
  null
  
)

export default component.exports